module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-98e07078.svg";